@import '../../theme.scss';

/* 菜单 */
.Menu {
    position: sticky;
    top: 0px;
    width: 100%;
    height: $menuHeight;
    background: inherit;
    background-size: cover;
    z-index: 1000;
    .Nav {
        width: $contentWidth;
        max-width: $contentMaxWidth;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: auto;
        line-height: $menuHeight;
        img {
            height: 45px;
        }
        a {
            font-size: 16px;
            color: #fff !important;
            margin-left: 20px;
        }
    }
}
